module.exports = __webpack_public_path__ + "static/media/svg-7.12726e96.svg";